/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The IdStringModel model module.
 * @module model/IdStringModel
 * @version v1.0.0
 */
class IdStringModel {
    /**
     * Constructs a new <code>IdStringModel</code>.
     * @alias module:model/IdStringModel
     */
    constructor() { 
        
        IdStringModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>IdStringModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/IdStringModel} obj Optional instance to populate.
     * @return {module:model/IdStringModel} The populated <code>IdStringModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new IdStringModel();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} id
 */
IdStringModel.prototype['id'] = undefined;






export default IdStringModel;

